export enum RePermitStatus {
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  EMPTY = 'EMPTY',
}
